import styled from 'styled-components';

export const Wrapper = styled.div<{ $isBook: boolean }>`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 93px;
  height: 93px;
  padding: 1px;
  background: ${({ $isBook }) => ($isBook ? 'var(--grey-100)' : 'var(--white)')};
  border: 1px solid var(--grey-400);
  border-radius: var(--radius-base);
  container-type: inline-size;

  & img {
    width: 100%;
    height: 100%;
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }

  & span {
    position: absolute;
    top: -11px;
    right: -11px;
  }
`;
